import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pretty_button m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slider = _resolveComponent("slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", null, _toDisplayString(_ctx.filter.name), 1),
    _createVNode(_component_slider, {
      min: _ctx.filter.min,
      max: _ctx.filter.max,
      modelValue: _ctx.values,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values) = $event)),
      range: true,
      "show-tooltip": "drag",
      lazy: false,
      "tooltip-position": "bottom",
      onChange: _ctx.onSliderChanged
    }, null, 8, ["min", "max", "modelValue", "onChange"]),
    _createElementVNode("div", null, " от " + _toDisplayString(_ctx.filter.values[0]) + " до " + _toDisplayString(_ctx.filter.values[1]) + " " + _toDisplayString(_ctx.filter.options.measure), 1)
  ]))
}